const VIEWS_KEY = 'views';
const storage = window.sessionStorage;

export default {
  getViews() {
    const views = JSON.parse(storage.getItem(VIEWS_KEY));
    if (!views) return [];
    return views;
  },
  setViews(data) {
    storage.setItem(VIEWS_KEY, JSON.stringify(data));
  },
  removeViews() {
    storage.removeItem(VIEWS_KEY);
  },
};
